export enum EnumARPaymentType {
  ValidValue = 'enumPaymentType',
  CreditCard = '00000080-1000-0000-0000-000000000003',
  Check = '00000080-1000-0000-0000-000000000001',
  Cash = '00000080-1000-0000-0000-000000000002',
  CreditCardOffline = '00000080-1000-0000-0000-000000000004',
  InternalCredit = '00000080-1000-0000-0000-000000000005',
}
